// extracted by mini-css-extract-plugin
module.exports = {"ratingsSectionWrapper":"TrustElements_ratingsSectionWrapper___VTqL","ratingSummaryWrapper":"TrustElements_ratingSummaryWrapper__By_BF","images":"TrustElements_images__XOJ8f"};